import Event from "domain/Event";

export const initState = {
    list: [],
    current: null,
    isLoading: false,
    hasFailed: false,
    pagination: {
        total: 0,
        page: 1,
        pageSize: 20,
        hasMore: false
    }
};

export default function eventReducer(state = initState, action) {
    const { type, payload } = action;

    switch (type) {
        case 'LIST_EVENT_PENDING': {
            return { ...state, isLoading: true, hasFailed: false };
        }

        case 'LIST_EVENT_REJECTED': {
            return { ...state, isLoading: false, hasFailed: true };
        }

        case 'LIST_EVENT_FULFILLED': {
            if (payload && payload.data && payload.pagination) {
                return {
                    ...state,
                    list: payload.data.map(item => new Event(item)),
                    pagination: payload.pagination,
                    isLoading: false,
                    hasFailed: false
                };
            } else {
                return {
                    ...state,
                    list: payload.map(item => new Event(item)),
                    pagination: { ...initState.pagination },
                    isLoading: false,
                    hasFailed: false
                };
            }
        }
        
        case 'LOAD_MORE_EVENT_PENDING': {
            return { ...state, isLoading: true, hasFailed: false };
        }

        case 'LOAD_MORE_EVENT_REJECTED': {
            return { ...state, isLoading: false, hasFailed: true };
        }

        case 'LOAD_MORE_EVENT_FULFILLED': {
            return {
                ...state,
                list: [...state.list, ...payload.data.map(item => new Event(item))],
                pagination: payload.pagination,
                isLoading: false,
                hasFailed: false
            };
        }

        case 'GET_EVENT_PENDING': {
            return { ...state, isLoading: true, hasFailed: false };
        }

        case 'GET_EVENT_REJECTED': {
            return { ...state, isLoading: false, hasFailed: true };
        }

        case 'GET_EVENT_FULFILLED': {
            return {
                ...state,
                current: new Event(payload),
                isLoading: false,
                hasFailed: false
            };
        }

        case 'SAVE_EVENT_PENDING': {
            return { ...state, isLoading: true, hasFailed: false };
        }

        case 'SAVE_EVENT_REJECTED': {
            return { ...state, isLoading: false, hasFailed: true };
        }

        case 'SAVE_EVENT_FULFILLED': {
            return {
                ...state,
                current: new Event(payload),
                isLoading: false,
                hasFailed: false
            };
        }

        case 'UPDATE_EVENT_PENDING': {
            return { ...state, isLoading: true, hasFailed: false };
        }

        case 'UPDATE_EVENT_REJECTED': {
            return { ...state, isLoading: false, hasFailed: true };
        }

        case 'UPDATE_EVENT_FULFILLED': {
            return {
                ...state,
                current: new Event(payload),
                list: state.list.map(event => 
                    event.id === payload.id ? new Event(payload) : event
                ),
                isLoading: false,
                hasFailed: false
            };
        }

        case 'DELETE_EVENT_PENDING': {
            return { ...state, isLoading: true, hasFailed: false };
        }

        case 'DELETE_EVENT_REJECTED': {
            return { ...state, isLoading: false, hasFailed: true };
        }

        case 'DELETE_EVENT_FULFILLED': {
            return {
                ...state,
                list: state.list.filter(event => event.id !== payload.id),
                current: state.current?.id === payload.id ? null : state.current,
                isLoading: false,
                hasFailed: false
            };
        }

        case 'CLEAR_EVENT': {
            return { ...initState };
        }

        case 'SET_CURRENT_EVENT': {
            return {
                ...state,
                current: payload ? new Event(payload) : null
            };
        }

        default: {
            return state;
        }
    }
}